import type {
  ConnectionProviderView,
  ConnectionView,
} from '@/lib/api/generated/model';

/** `https://ghcr.io/` → `ghcr.io`; a bare host passes through. */
function hostOf(value: string): string {
  return value.replace(/^[a-z]+:\/\//i, '').replace(/\/+$/, '');
}

/**
 * The Connected row's second line (spec 229 research R2): what the person
 * wrote about the connection; otherwise which host it reaches, read from the
 * config at the provider's own url or host field; otherwise the environment
 * the provider exposes, which is what the Secrets tiles used to say.
 */
export function connectionSummaryLine(
  provider: ConnectionProviderView | undefined,
  connection: ConnectionView,
): string {
  const description = connection.description?.trim();
  if (description) return description;

  const hostField = provider?.fields.find(
    (field) =>
      field.kind === 'url' ||
      field.env?.endsWith('_HOST') === true ||
      field.env?.endsWith('_URL') === true,
  );
  const raw = hostField ? connection.config[hostField.name] : undefined;
  if (typeof raw === 'string' && raw.trim() !== '') return hostOf(raw.trim());

  const env = provider ? provider.exposed_env : connection.exposed_env;
  return env.join(' · ');
}
